import { MarketplacePath } from "utils/routes";

export const CONFIG_MARKET_PLACE = {
    ORDER_NEW_DEVICE: 'orderNewDevice',
    RETURN_DEVICE: 'returnDevice',
    DXC_GEAR: 'dxcGear',
    ORDER_VIRTUAL_MACHINE: 'orderVirtualMachine',
    COMING_SOON: 'comingSoon',
    ORDER_VIRTUAL_APP: 'orderVirtualApp',
};

export const MARKETPLACE_CATEGORY_URL = `${MarketplacePath}/category`;
